import { atom, useAtom } from "jotai";

export const getInTouchModalOpenAtom = atom(false);

export function useGetInTouchModal() {
  const [getInTouchModal, setGetInTouchModal] = useAtom(
    getInTouchModalOpenAtom,
  );

  const showGetInTouchModal = () => {
    // console.log("show");
    setGetInTouchModal(true);
  };

  const hideGetInTouchModal = () => {
    // console.log("hide");

    setGetInTouchModal(false);
  };

  return {
    showGetInTouchModal,
    hideGetInTouchModal,
    isGetInTouchModalVisible: getInTouchModal,
  };
}
